import * as React from "react";
import * as ReactDOM from "react-dom";
import { getbaseURL, doFetchBuildCSV, downloadPDF } from "../../../utils";
import { IExplorerProperties } from "../../../models";
const styles = require("./DownloadButton.pcss");
import { ExplorerTabDailyPrices, ExplorerTabPerformance, ExplorerTabCharges, ExplorerTabYield } from "../../FundExplorerTabs";
import { BASE_SEARCH_REQUEST } from "../../../data";

interface IProps {
    styles?: Object;
}

interface IState {
    visible?: boolean;
    downloadingCSV?: boolean;
}

export class DownloadButton extends React.Component<IProps & IExplorerProperties, IState>{
    constructor(props) {
        super(props)

        this.state = {
            visible: false,
            downloadingCSV: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.downloadPdf = this.downloadPdf.bind(this);
        this.downloadCsv = this.downloadCsv.bind(this);
        this.toggleDownloadingCSV = this.toggleDownloadingCSV.bind(this);
    }

    toggle() {
        this.setState({ visible: !this.state.visible }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener("click", this.handleDocumentClick, true);
    }

    toggleDownloadingCSV() {
        this.setState({ downloadingCSV: !this.state.downloadingCSV })
    }

    removeEvents() {
        document.removeEventListener("click", this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);
        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggle();
    }

    downloadPdf() {
        let { appParams, sorting, activeTabKey, filter } = this.props;
        let { clienttype, language, productrange, region, _location } = appParams;
        let { sortOrder } = sorting;

        let baseUrl = getbaseURL();
        let filename = `Fund-Explorer-${ appParams.productrange }-${ appParams.clienttype }-${ appParams.region }-${ appParams.language }`;
        let url = `${ baseUrl }fund-explorer-pdf/${ activeTabKey }/${ sortOrder }/${ productrange }/${ region }/${ clienttype }/${ language }?options=${ JSON.stringify(filter) }`;
        downloadPDF(url, filename);
        this.toggle();
    }

    async downloadCsv() {
        this.toggleDownloadingCSV();
        let table, columns;
        let { appParams, sorting, activeTabKey, filter } = this.props;
        let { clienttype, language, productrange, region, _location } = appParams;
        let { sortOrder } = sorting;

        let isPPL = productrange.toUpperCase() === "PPL";

        if (activeTabKey === "dailyPrices") {
            table = new ExplorerTabDailyPrices(this.props);
            columns = table.getColumns(isPPL, true);
        }
        if (activeTabKey === "performance") {
            table = new ExplorerTabPerformance(this.props);
            columns = table.getColumns(isPPL, true);
        }
        if (activeTabKey === "fundCharges") {
            table = new ExplorerTabCharges(this.props);
            columns = table.getColumns(isPPL, true);
        }

        this.toggle();
        let doneLoading = await doFetchBuildCSV(filter, appParams, columns, activeTabKey);
        this.toggleDownloadingCSV();
    }

    render() {
        let visibility = this.state.visible ? styles.active : "";
        let { downloadingCSV } = this.state;
        let internalClasses = {
            dropdown: `${ styles.dropdown } ${ visibility }`,
            arrow: `${ styles.arrow } ${ visibility }`
        };
        return (
            <div className={ `${ styles.downloadWrapper }  ${ downloadingCSV ? styles.downloadWrapperLoading : ""}` } >
                <div className={ styles.downloadButton } onClick={ this.toggle }>
                    { downloadingCSV ? "DOWNLOADING..." : "DOWNLOAD" }
                </div>
                <section tabIndex={ 0 } className={ internalClasses.dropdown }>
                    <div className={ styles.options }>
                        <ul>
                            <li onClick={ this.downloadPdf }>Download PDF</li>
                            <li onClick={ this.downloadCsv }>Download CSV</li>
                        </ul>
                    </div>
                </section>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/components/FundPages/DownloadButton/DownloadButton.tsx